window.addEventListener("load", function () {
  
    $(".gift__list--item").each(function(index) {
        var $btnNhan = $(this).find(".btn-nhan");
        
        if ($(this).hasClass("received")) {
          $btnNhan.text($btnNhan.data("received"));
      } else {
          $btnNhan.text($btnNhan.data("default")) ;
      }
        
    });

});
